import { render, staticRenderFns } from "./DialogCalidadDatos.vue?vue&type=template&id=5c91a63e&scoped=true"
import script from "./DialogCalidadDatos.vue?vue&type=script&lang=js"
export * from "./DialogCalidadDatos.vue?vue&type=script&lang=js"
import style0 from "./DialogCalidadDatos.vue?vue&type=style&index=0&id=5c91a63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91a63e",
  null
  
)

export default component.exports